import { render, staticRenderFns } from "./noticeList.vue?vue&type=template&id=4ca5f1a6&scoped=true"
import script from "./noticeList.vue?vue&type=script&lang=js"
export * from "./noticeList.vue?vue&type=script&lang=js"
import style0 from "./noticeList.vue?vue&type=style&index=0&id=4ca5f1a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca5f1a6",
  null
  
)

export default component.exports